import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isCurrentUserAdmin, signInAdmin, signOut } from "../supabase/authService";

export default function Login() {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const navigate = useNavigate();
  const location = useLocation() as any;
  const from: string = location.state?.from ?? "/admin";

  async function handleAfterLogin() {
    const isAdmin = await isCurrentUserAdmin();
    if (isAdmin) {
      navigate(from, { replace: true });
    } else {
      setError("Bu hesapta admin yetkisi yok.");
      await signOut();
    }
  }

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await signInAdmin(email.trim(), password);
      await handleAfterLogin();
    } catch (err: any) {
      setError(err.message ?? "Giriş başarısız.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      maxWidth: 360,
      margin: "64px auto",
      padding: 24,
      border: "1px solid #eee",
      borderRadius: 12,
      boxShadow: "0 6px 20px rgba(0,0,0,0.06)"
    }}>
      <h1 style={{ marginBottom: 16 }}>Admin Giriş</h1>

      <form onSubmit={onSubmit}>
        <label style={{ display: "block", marginBottom: 8 }}>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ width: "100%", padding: 10, marginTop: 6, borderRadius: 8, border: "1px solid #ccc" }}
          />
        </label>

        <label style={{ display: "block", marginBottom: 16 }}>
          Şifre
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ width: "100%", padding: 10, marginTop: 6, borderRadius: 8, border: "1px solid #ccc" }}
          />
        </label>

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%", padding: 12, borderRadius: 10, border: "none",
            cursor: "pointer", marginBottom: 12
          }}
        >
          {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
        </button>
      </form>

      {error && (
        <p style={{ color: "crimson", marginTop: 12 }}>{error}</p>
      )}
    </div>
  );
}
